import { render, staticRenderFns } from "./association-detail.vue?vue&type=template&id=2e45bab6&scoped=true"
import script from "./association-detail.vue?vue&type=script&lang=js"
export * from "./association-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e45bab6",
  null
  
)

export default component.exports